var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85707 6.42856H7.4285M1.99993 1.28571V9.85714V1.28571ZM0.285645 8.71428H1.71422H0.285645ZM3.71422 3.57142H2.28564H3.71422ZM7.14279 0.714279V9.28571V0.714279ZM5.4285 2.42856H6.85707H5.4285Z",
    stroke: "white",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleBars);
export default __webpack_public_path__ + "static/media/chart-style-bars.46a4b79fc8a4518a914b8a566e98778f.svg";
export { ForwardRef as ReactComponent };